document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initNieve();
  initGaleriaProducto();
  initOpcionesProducto();
  initBarraMovil();
  initResenasDrag();
});

function reducirMovimiento() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function initReveal() {
  var els = document.querySelectorAll('.sp-reveal');
  if (!els.length) return;
  if (reducirMovimiento() || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('sp-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sp-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
  );
  els.forEach(function (el, i) {
    el.style.setProperty('--sp-delay', (i % 5) * 0.09 + 's');
    observer.observe(el);
  });
}

function initNieve() {
  var contenedores = document.querySelectorAll('[data-sp-nieve]');
  if (!contenedores.length || reducirMovimiento()) return;
  var colores = ['#C9A24B', '#B3122B', '#C9A24B', '#16382C'];
  contenedores.forEach(function (caja) {
    var cantidad = parseInt(caja.getAttribute('data-sp-nieve'), 10) || 0;
    if (window.innerWidth < 640) cantidad = Math.round(cantidad * 0.6);
    for (var i = 0; i < cantidad; i++) {
      var copo = document.createElement('span');
      copo.className = 'sp-copo';
      copo.textContent = i % 3 === 0 ? '✦' : '❄';
      copo.setAttribute('aria-hidden', 'true');
      copo.style.setProperty('--x', Math.round(Math.random() * 100) + '%');
      copo.style.setProperty('--s', (10 + Math.random() * 16).toFixed(0) + 'px');
      copo.style.setProperty('--o', (0.18 + Math.random() * 0.32).toFixed(2));
      copo.style.setProperty('--t', (11 + Math.random() * 12).toFixed(1) + 's');
      copo.style.setProperty('--d', (-Math.random() * 20).toFixed(1) + 's');
      copo.style.setProperty('--c', colores[i % colores.length]);
      caja.appendChild(copo);
    }
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-sp-galeria]').forEach(function (galeria) {
    var img = galeria.querySelector('[data-sp-galeria-principal] img');
    var thumbs = galeria.querySelectorAll('[data-sp-thumb]');
    if (!img || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        img.setAttribute('src', full);
        img.setAttribute('alt', thumb.getAttribute('data-alt') || '');
        thumbs.forEach(function (t) { t.classList.remove('sp-activo'); });
        thumb.classList.add('sp-activo');
      });
    });
  });
}

function initOpcionesProducto() {
  document.querySelectorAll('[data-sp-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-sp-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var seccion = form.closest('[data-sp-producto]') || document;
    var idInput = form.querySelector('input[name="id"]');
    var precios = seccion.querySelectorAll('[data-sp-precio-actual]');
    var anterior = seccion.querySelector('[data-sp-precio-anterior]');
    var btn = form.querySelector('[data-sp-btn-comprar]');
    var aviso = form.querySelector('[data-sp-agotado]');
    var grupos = form.querySelectorAll('[data-sp-opcion-grupo]');
    var futuro = seccion.querySelector('[data-sp-precio-futuro]');

    function actualizar() {
      var sel = [];
      grupos.forEach(function (g) {
        var a = g.querySelector('.sp-activo');
        sel.push(a ? a.getAttribute('data-valor') : null);
      });
      var v = variantes.find(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!v) return;
      idInput.value = v.id;
      precios.forEach(function (p) { p.textContent = v.price_formatted; });
      if (anterior) {
        if (v.compare_at_price_formatted) {
          anterior.textContent = v.compare_at_price_formatted;
          anterior.style.display = '';
        } else {
          anterior.style.display = 'none';
        }
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-texto-disponible') : btn.getAttribute('data-texto-agotado');
      }
      if (aviso) aviso.style.display = v.available ? 'none' : '';
      var barraBtn = seccion.querySelector('[data-sp-barra-btn]');
      if (barraBtn) barraBtn.disabled = !v.available;

      if (futuro) {
        var activo = null;
        grupos.forEach(function (g) {
          var a = g.querySelector('.sp-activo');
          if (a && a.getAttribute('data-futuro')) activo = a;
        });
        var futuroValor = activo ? activo.getAttribute('data-futuro') : '';
        if (futuroValor) {
          var prefijo = futuro.getAttribute('data-prefijo') || '';
          var sufijo = futuro.getAttribute('data-sufijo') || '';
          futuro.innerHTML = (prefijo ? prefijo + ' ' : '') + '<del>' + futuroValor + '</del>' + (sufijo ? ' ' + sufijo : '');
          futuro.style.display = '';
        } else {
          futuro.style.display = 'none';
        }
      }
    }

    grupos.forEach(function (g) {
      g.querySelectorAll('[data-sp-opcion-valor]').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('[data-sp-opcion-valor]').forEach(function (x) { x.classList.remove('sp-activo'); });
          b.classList.add('sp-activo');
          actualizar();
        });
      });
    });
    actualizar();
  });
}

function initBarraMovil() {
  var barra = document.querySelector('[data-sp-barra]');
  var principal = document.querySelector('[data-sp-btn-comprar]');
  if (!barra || !principal || !('IntersectionObserver' in window)) return;
  var form = principal.closest('form');
  var barraBtn = barra.querySelector('[data-sp-barra-btn]');
  if (barraBtn && form) {
    barraBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(principal); else principal.click();
    });
  }
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      barra.classList.toggle('sp-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
  }).observe(principal);
}

function initResenasDrag() {
  document.querySelectorAll('.sp-resenas-track').forEach(function (track) {
    var isDown = false, startX = 0, scrollLeft = 0;
    track.addEventListener('mousedown', function (e) {
      isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () { isDown = false; });
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX) * 1.2;
    });
  });
}
